export function getNowAsIsoDate(): string {
  const iso = new Date().toISOString();
  const [date] = iso.split('T');
  return date;
}
